import CryptoJS from 'crypto-js';

export const miaomiaoKey = CryptoJS.enc.Utf8.parse(")O[NA]6,YF}+efcaj{+oESb9d8>Z'e9B");
export const miaomiaoIV = CryptoJS.enc.Utf8.parse('');

/**
 * 喵喵数据加密
 * @param word 
 * @returns 
 */
export function MiaoMiaoEncrypt(word: string) {
    let encrypted = CryptoJS.AES.encrypt(word, miaomiaoKey, { iv: miaomiaoIV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}

/**
 * 喵喵数据解密
 * @param word 
 * @returns 
 */
export function MiaoMiaoDecrypt(word: string) {
    var decrypt = CryptoJS.AES.decrypt(word, miaomiaoKey, { iv: miaomiaoIV, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
